<script setup lang="ts">
import Editor from "primevue/editor";
import {Label} from "@/Components/Library";

type Props = {
    label?: string;
    hint?: string;
    rows?: number;
    id: string;
};

const props = withDefaults(defineProps<Props>(), {
    rows: 2,
});

const modelValue = defineModel<string | null | undefined>();

const emit = defineEmits(["update:modelValue"]);
</script>
<template>
    <div class="w-full grow">
        <Label v-if="props.label" :for="id" class="mb-1">{{ props.label }}</Label>
        <Editor
            v-bind="$attrs"
            :model-value="modelValue !== null ? modelValue : undefined"
            @update:modelValue="modelValue = $event"
        >
            <template v-slot:toolbar>
                <span class="ql-formats">
                    <select class="ql-header">
                        <option value="1">Heading</option>
                        <option value="2">Subheading</option>
                        <option value="0">Normal</option>
                    </select>
                    <!--                    <select class="ql-font">-->
                    <!--                        <option></option>-->
                    <!--                        <option value="serif"></option>-->
                    <!--                        <option value="monospace"></option>-->
                    <!--                    </select>-->
                </span>
                <span class="ql-formats">
                    <button class="ql-bold" type="button"></button>
                    <button class="ql-italic" type="button"></button>
                    <button class="ql-underline" type="button"></button>
                </span>
                <span class="ql-formats">
                    <select class="ql-color"></select>
                    <select class="ql-background"></select>
                </span>
                <span class="ql-formats">
                    <button class="ql-list" value="ordered" type="button"></button>
                    <button class="ql-list" value="bullet" type="button"></button>
                    <select class="ql-align">
                        <option value></option>
                        <option value="center"></option>
                        <option value="right"></option>
                        <option value="justify"></option>
                    </select>
                </span>
                <span class="ql-formats">
                    <button class="ql-link" type="button"></button>
                    <!--                                <button class="ql-image" type="button"></button>-->
                    <!--                    <button class="ql-code-block" type="button"></button>-->
                </span>
                <!--                <span class="ql-formats">-->
                <!--                    <button class="ql-clean" type="button"></button>-->
                <!--                </span>-->
            </template>
        </Editor>
        <div>
            <slot name="hint">
                <span v-if="hint" class="mt-1 block text-sm" v-html="hint"></span>
            </slot>
        </div>
    </div>
</template>
